module.exports = __webpack_public_path__ + "img/executive_session.66595a46.svg";